import { DeviceType } from '#pplx/frontend/apps/ask/keyboards/keyboards-core/consts.js';
// Map actual key values to display icons (symbol style)
const keyToDisplayMapSymbols = {
    Meta: '⌘',
    Alt: '⌥',
    Shift: '⇧',
    ArrowUp: '↑',
    ArrowDown: '↓',
    ArrowLeft: '←',
    ArrowRight: '→',
    Enter: '⏎',
    Period: '.',
    Semicolon: ';',
    Slash: '/',
    Escape: 'Esc',
};
// Map actual key values to full text labels
const keyToDisplayMapText = {
    Meta: 'Cmd',
    Alt: 'Alt',
    Shift: 'Shift',
    ArrowUp: '↑',
    ArrowDown: '↓',
    ArrowLeft: '←',
    ArrowRight: '→',
    Enter: 'Enter',
    Period: '.',
    Semicolon: ';',
    Slash: '/',
    Escape: 'Esc',
};
// Map display icons to actual key values
const displayToKeyMap = {
    '⌘': 'Meta',
    '⌥': 'Alt',
    '⇧': 'Shift',
    '↑': 'ArrowUp',
    '↓': 'ArrowDown',
    '←': 'ArrowLeft',
    '→': 'ArrowRight',
    '⏎': 'Enter',
    Cmd: 'Meta',
    Ctrl: 'Control',
    Opt: 'Alt',
};
export const convertKeyToDisplay = (key, device = DeviceType.MACOS, style = 'symbols') => {
    const displayMap = style === 'text' ? keyToDisplayMapText : keyToDisplayMapSymbols;
    if (key === 'Meta') {
        if (style === 'text') {
            return device === DeviceType.WINDOWS ? 'Win' : 'Cmd';
        }
        return device === DeviceType.WINDOWS ? 'Win' : '⌘';
    }
    if (key === 'Control') {
        return style === 'text' ? 'Ctrl' : '⌃';
    }
    return displayMap[key] || key;
};
export const convertDisplayToKey = (displayKey) => {
    if (displayKey === 'Win') {
        return 'Meta';
    }
    return displayToKeyMap[displayKey] || displayKey;
};
//# sourceMappingURL=utils.js.map